import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonColorExpanded, SPACING, Typography } from "@joonapp/web-shared"
import { FlexBox } from "@joonapp/web-shared"
import { JoonUIColor } from "@joonapp/web-shared"

const TabItem = ({
  label,
  onClick,
  icon,
  isSelected,
  size = "medium",
}: {
  label: string
  onClick: () => void
  icon: IconDefinition
  isSelected: boolean
  size?: "small" | "medium"
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <FlexBox
        direction="row"
        align="center"
        gap={SPACING.space2}
        style={{ padding: `${SPACING.space2} ${SPACING.space4}` }}
      >
        <FontAwesomeIcon
          icon={icon}
          size="lg"
          style={{
            // @ts-ignore
            "--fa-primary-color": isSelected
              ? JoonUIColor.icon.accent
              : JoonUIColor.icon.neutral,
            "--fa-secondary-color": isSelected
              ? JoonColorExpanded.indigo200
              : JoonUIColor.icon.light,
          }}
        />
        <Typography
          variant={size === "small" ? "bodySmall" : "body"}
          color={
            isSelected ? JoonUIColor.text.primary : JoonUIColor.text.secondary
          }
        >
          {label}
        </Typography>
      </FlexBox>
      <div
        style={{
          height: size === "small" ? 2 : 4,
          backgroundColor: isSelected
            ? JoonUIColor.semantic.primary
            : "transparent",
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
        }}
      />
    </button>
  )
}

export default TabItem
